window.addEventListener('DOMContentLoaded', () => {
    // Return if is in admin to prevent the block from breaking.
    if (typeof initializer !== 'undefined' && initializer.isAdmin) return;

    // Consts
    const header = document.querySelector('.component-header');
    const menuTour = document.querySelector('.block-menu-tour');
    const STICKY_SCROLL_OFFSET = 100; // The point at which the header becomes sticky

    function getHeaderHeight() {
        //return header ? header.clientHeight : 0;
        let scroll = 0;

        if (header) {
            scroll = scroll + header.clientHeight;
        }


        if (menuTour) {
            scroll = scroll + menuTour.clientHeight;
        }

        return scroll;
    }

    function smoothScrollTo(targetId) {
        const targetSection = document.getElementById(targetId);
        if (targetSection) {
            const initialHeaderHeight = getHeaderHeight();
            const offsetTop = targetSection.getBoundingClientRect().top + window.scrollY - initialHeaderHeight;
            window.scrollTo({ behavior: 'smooth', top: offsetTop });

            // Continuously adjust the scroll position until the target section is in view
            const interval = setInterval(() => {
                const currentHeaderHeight = getHeaderHeight();
                const newOffsetTop = targetSection.getBoundingClientRect().top + window.scrollY - currentHeaderHeight;
                if (Math.abs(window.scrollY - newOffsetTop) > 1) {
                    window.scrollTo({ top: newOffsetTop });
                } else {
                    clearInterval(interval);
                }
            }, 100);
        }
    }

    function handlePageLoadWithHash() {
        const initialHash = window.location.hash;
        if (initialHash) {
            window.history.replaceState(null, null, ' ');
            window.scrollTo(0, 0);
            setTimeout(() => {
                const targetId = initialHash.substring(1);
                window.history.replaceState(null, null, initialHash);
                smoothScrollTo(targetId);
            }, 500);
        }
    }

    function handleLinkClick(event, href, targetId) {
        event.preventDefault();
        if (href.startsWith('#')) {
            window.history.pushState(null, null, href);
            smoothScrollTo(targetId);
        } else if (href.startsWith(window.location.origin)) {
            if (href.split('#')[0] === window.location.origin + window.location.pathname) {
                window.history.pushState(null, null, href);
                smoothScrollTo(targetId);
            } else {
                sessionStorage.setItem('targetHash', targetId);
                window.location.href = href;
            }
        }
    }

    function initializeLinks() {
        const links = document.querySelectorAll('a[href*="#"]');
        links.forEach(link => {
            link.addEventListener('click', function (event) {
                const href = this.getAttribute('href');
                const targetId = href.split('#')[1];
                handleLinkClick(event, href, targetId);
            });
        });
    }

    function handleStoredHash() {
        const storedHash = sessionStorage.getItem('targetHash');
        if (storedHash) {
            sessionStorage.removeItem('targetHash');
            window.scrollTo(0, 0);
            setTimeout(() => {
                smoothScrollTo(storedHash);
            }, 500);
        }
    }

    function initialize() {
        handlePageLoadWithHash();
        initializeLinks();
        handleStoredHash();
        window.addEventListener('hashchange', () => {
            const targetId = window.location.hash.substring(1);
            smoothScrollTo(targetId);
        });
    }

    initialize();
});
